import React from 'react';
import {
  BERRY_AI_INTEGRATIONS_LS_KEY,
  loadConnectedAiApiKeyIntegrationsFromBrowser,
} from 'utils/ai-integrations-browser-storage';

const GEMINI_ID = 'google_gemini_integration';

export const GEMINI_DEFAULT_MODEL_FALLBACK = 'gemini-2.5-flash';

export type GeminiConnectionState = {
  connected: boolean;
  apiKey: string;
  defaultModel: string;
};

function readGemini(): GeminiConnectionState {
  const rows = loadConnectedAiApiKeyIntegrationsFromBrowser();
  const r = rows.find((x) => x.id === GEMINI_ID);
  const key = r?.config?.apiKey?.trim() ?? '';
  return {
    connected: Boolean(key),
    apiKey: key,
    defaultModel: r?.config?.defaultModel?.trim() || GEMINI_DEFAULT_MODEL_FALLBACK,
  };
}

/** Imperative read (e.g. when opening a menu). */
export function getGeminiConnectionSnapshot(): GeminiConnectionState {
  return readGemini();
}

/**
 * Current Google Gemini API key + default model from Integrations (browser storage).
 */
export function useGeminiConnection(): GeminiConnectionState {
  const [state, setState] = React.useState<GeminiConnectionState>(readGemini);

  React.useEffect(() => {
    const sync = () => setState(readGemini());
    const onStorage = (e: StorageEvent) => {
      if (!e.key || e.key === BERRY_AI_INTEGRATIONS_LS_KEY) sync();
    };
    window.addEventListener('storage', onStorage);
    /** Same-tab saves use localStorage without firing `storage`; refresh when the window regains focus. */
    window.addEventListener('focus', sync);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('focus', sync);
    };
  }, []);

  return state;
}
